export const LogoMark = ({ size = 28 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        aria-hidden="true"
    >
        <rect
            width="64"
            height="64"
            rx="15"
            fill="#0E0E10"
            stroke="rgba(201,247,58,0.35)"
            strokeWidth="2"
        />
        <g
            transform="rotate(-26 32 32)"
            stroke="#C9F73A"
            strokeWidth="5"
            strokeLinecap="round"
        >
            <line x1="17" y1="32" x2="47" y2="32" />
            <line x1="17" y1="23" x2="17" y2="41" />
            <line x1="24.5" y1="27" x2="24.5" y2="37" />
            <line x1="47" y1="23" x2="47" y2="41" />
            <line x1="39.5" y1="27" x2="39.5" y2="37" />
        </g>
    </svg>
);
